import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import {
	stagesAction,
	levelsAction,
	singleLevelAction,
	settingsAction,
	badgesAction,
	partsAction
} from '../../actions/contentActions'
import { get } from '../../services/apiServices'
import { token } from '../../services/authServices'
import { connect } from 'react-redux'
import StagesTree from '../content/StagesTree'
import LevelSingle from '../content/LevelSingle'
import Settings from '../content/Settings'
import Badges from '../content/Badges'
import BotParts from '../content/BotParts'
import PlayerProgress from '../content/PlayerProgress'
import Cache from '../content/Cache'
import Tabs from 'material-ui/Tabs';
import { Tab } from 'material-ui/Tabs';


const styles = {
	table: {
		minWidth: 700,
	}
};

class Admin extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeStage: '',
			activeTab: 0
		}
	}

	componentDidMount() {
		/* this.props.history.listen((obj, action) => {
			const isLevels = this.props.match.params ?
				this.props.match.params.id : false

			if ((action == "POP" && isLevels)) {
				this.locationListener()
			}

		})

		this.locationListener() */

	}

	classes = this.props.classes;

	handleTabChange = (event, activeTab) => {
		this.setState({ activeTab });
	}

	render() {
		const id = this.props.match.params ?
			this.props.match.params.id : null
		const levelSingle = /levels/.test(this.props.match.path)
		const edit = /edit/.test(this.props.match.path)
		const activeTab = this.state.activeTab
		return (
			<div>
				<div className="top-panel">
					<Tabs
						indicatorColor="primary"
						textColor="primary"
						value={activeTab}
						onChange={this.handleTabChange}>
						<Tab label="Level builder" />
						<Tab label="Settings" />
						<Tab label="Badges" />
						<Tab label="Bot Parts" />
						<Tab label="Player Progress" />
						<Tab label="Cache" />
					</Tabs>
				</div>
				{activeTab === 0 && <div>
					{!id && !levelSingle && <StagesTree
						getStages={this.props.getStages}
						stages={this.props.stages} />}
					{id && levelSingle && <LevelSingle
						getSingleLevel={this.props.getSingleLevel}
						getStages={this.props.getStages}
						stages={this.props.stages}
						singleLevel={this.props.singleLevel}
						levelId={id}
						activeStage={this.state.activeStage}
					/>
					}
				</div>}
				{activeTab === 1 && <div>
					<Settings
						getSettings={this.props.getSettings}
						settings={this.props.settings}
					/>
				</div>}
				{activeTab === 2 && <div>
					<Badges
						getBadges={this.props.getBadges}
						badges={this.props.badges}
					/>
				</div>}
				{activeTab === 3 && <div>
					<BotParts
						getParts={this.props.getParts}
						parts={this.props.parts}
					/>
				</div>}
				{activeTab === 4 && <div>
					<PlayerProgress
						getStages={this.props.getStages}
						stages={this.props.stages} />
				</div>}
				{activeTab === 5 && <div>
					<Cache
						getStages={this.props.getStages}
						stages={this.props.stages} />
				</div>}

			</div>
		)
	}

}

Admin = connect(
	state => ({
		stages: state.stages,
		levels: state.levels,
		singleLevel: state.singleLevel,
		settings: state.settings,
		badges: state.badges,
		parts: state.parts
	}),
	dispatch => ({
		bridge: data => dispatch(data),
		getStages: data => dispatch(stagesAction(1, true, true)),
		getSingleLevel: id => dispatch(singleLevelAction(id)),
		getSettings: data => dispatch(settingsAction(data)),
		getBadges: data => dispatch(badgesAction(data)),
		getParts: data => dispatch(partsAction(data)),
	})
)(Admin);

export default withStyles(styles)(Admin);



// WEBPACK FOOTER //
// ./src/components/containers/AdminContainer.js